import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    layoutScrollable: (state) => state.layoutScrollable,
    layoutMode: (state) => state.layoutMode,
    leftSidebarType: (state) => state.leftSidebarType,
    sidebarColor: (state) => state.sidebarColor,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    breadCrumbs: (state) => state.breadCrumbs,
    title: (state) => state.title
  })
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutMode', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeSidebarColor', 'changeLayoutPosition', 'changeBreadCrumb','changeTitle'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const customerMethods = mapActions('customer', [
  'getRegionList',
  'getProvinceList',
  'getCityList',
  'getBarangayList',
  'getBusinessTypesList',
  'getBusinessList',
  'getBusinessDetails',
  'getBusinessCustomersList',
  'getBusinessProductsList',
  'getSubscriberList',
  'getSubscriberDetails',
  'actionKYC',
  'updateVerifiedKYC',
  'updateWalletStatus',
  'getReasonLogsList',
  'actionBusinessInfos',
  'getUserWalletsList',
  'updateUserWalletStatus',
  'sendSecQue',
  'fetchSecQueHistory',
  'updateMdrWhitelist',
  'getSubscriberListv2',
  'getBusinessDetailsv2',
  'getKankolekMDR',
  'getKankolekMdrLogs',
  'getUserKankolekQR',
  'updateWatchlistStatus',
  'updateStoreCategory'
])

export const customerListComputed = {
  ...mapState('customer', {
    regionList: (state) => state.regionList,
    provinceList: (state) => state.provinceList,
    cityList: (state) => state.cityList,
    barangayList: (state) => state.barangayList,
    businessTypesList: (state) => state.businessTypesList,
    businessList: (state) => state.businessList,
    businessListTotal: (state) => state.businessPageInfo.total,
    customerList: (state) => state.businessCustomerList,
    customerTotal: (state) => state.businessCustomerPageInfo.total,
    productList: (state) => state.businessProductList,
    productTotal: (state) => state.businessProductPageInfo.total,
    businessDetails: (state) => state.businessDetails,
    socialMedias: (state) => state.businessSocialMedias,
    subscriberList: (state) => state.subscriberList,
    subscriberListTotal: (state) => state.subscriberPageInfo.total,
    subscriberDetails: (state) => state.subscriberDetails,
    subscriberIDs: (state) => state.subscriberIDs,
    reasonLogsList: (state) => state.reasonLogsList,
    reasonLogsTotal: (state) => state.reasonLogsPageInfo.total,
    businessQr: (state) => state.businessQr,
    secQueHistory: (state) => state.secQueHistory
  })
}

export const todoComputed = {
  ...mapState('todo', {
    todos: (state) => state.todos
  })
}
export const todoMethods = mapActions('todo', ['fetchTodos'])

export const productListMethods = mapActions('product', [
  'listBusinessCategories',
  'createBusinessCategory',
  'updateBusinessCategory',
  'deleteBusinessCategory',
  'listProductTemplates',
  'createProductTemplate',
  'updateProductTemplate',
  'deleteProductTemplate',
  'getProductTemplate',
  'listProductGroups',
  'createProductGroup',
  'updateProductGroup',
  'deleteProductGroup',
  'listProductBrands',
  'createProductBrand',
  'updateProductBrand',
  'deleteProductBrand',
  'uploadLogo',
  'getUnitOfMeasureList',
  'newUnitOfMeasure',
  'delUnitOfMeasure',
  'setProductSuggestionList',
  'bulkCreateProductTemplate'
])

export const productListComputed = {
  ...mapState('product', {
    businessCategories: (state) => state.businessCategories,
    categoryTotalRows: (state) => state.businessCategoriesPage.totalRows,
    categoryTotalPage: (state) => state.businessCategoriesPage.totalPage,
    productGroups: (state) => state.productGroups,
    groupTotalRows: (state) => state.productGroupsPage.totalRows,
    groupTotalPage: (state) => state.productGroupsPage.totalPage,
    productTemplates: (state) => state.productTemplates,
    templateTotalRows: (state) => state.productTemplatesPage.totalRows,
    templateTotalPage: (state) => state.productTemplatesPage.totalPage,
    productBrands: (state) => state.productBrands,
    brandTotalRows: (state) => state.productBrandsPage.totalRows,
    brandTotalPage: (state) => state.productBrandsPage.totalPage,
    unitOfMeasurementList: (state) => state.unitOfMeasurementList,
    productSuggestionList: (state) => state.productSuggestionList,
    productSuggestionsCount: (state) => state.productSuggestionsCount
  })
}

export const digitalLoadMethods = mapActions('digitalLoad', [
  'getLoadPromoList',
  'actionLoadPromo',
  'getLoadCategoryList',
  'actionCategory',
  'getLoadTopupsList',
  'actionTopups',
  'getEloadPromoDetails',
  'getEloadCategoryDetails',
  'getEloadNetworkList',
  'getEloadBannerList',
  'getEloadNetworkListAll',
  'getEloadNetworkGroupListAll',
  'createEloadBanner',
  'actionNetwork',
  'actionNetworkGroup',
  'deleteEloadBanner',
  'getEloadBannerInfo',
  'updateEloadBanner',
  'getEloadBannerSequenceList',
  'getNetworkInfo',
  'getNetworkGroupInfo',
  'getEloadCampaignList',
  'createEloadCampaign',
  'getEloadCampaignDetails',
  'updateEloadCampaign',
  'deleteEloadCampaign',
  'updateEloadCampaignStatus',
  'performCampaignAction',
  'getEloadProviders',
  'getEloadNetworkGroups',
  'actionProvider',
  'getEloadCampaignPresets',
  'endEloadCampaign',
  'voidEloadCampaign',
  'updatePromoStatus',
  'fetchCampaignLineManagers',
  'getRebateLogsList',
  'getScheduleRebateLogsList',
  'actionEloadPromoSchedule',
  'getLoadSpecialCategoryList',
  'actionSpecialCategory',
  'getAllLoadSpecialCategoryList',
  'actionMassEloadPromoUpdate',
  'uploadSpecialCategoryIcon2',
  'getLoadSpecialCategoryDetails',
  'getSkuFieldLogs'
])

export const digitalLoadComputed = {
  ...mapState('digitalLoad', {
    loadPromoList: (state) => state.loadPromoList,
    loadPromoTotalRows: (state) => state.loadPromoPageInfo.total,
    loadCategoryList: (state) => state.loadCategoryList,
    loadCategoryTotalRows: (state) => state.loadCategoryPageInfo.total,
    loadSpecialCategoryList: (state) => state.loadSpecialCategoryList,
    loadSpecialCategoryTotalRows: (state) => state.loadSpecialCategoryPageInfo.total,
    loadSpecialCategoryDetails: (state) => state.loadSpecialCategoryDetails,
    loadAllSpecialCategoryList: (state) => state.loadAllSpecialCategoryList,
    loadTopupsList: (state) => state.loadTopupsList,
    loadTopupsTotalRows: (state) => state.loadTopupsPageInfo.total,
    loadNetworkList: (state) => state.loadNetworkList,
    loadNetworkTotalRows: (state) => state.loadNetworkPageInfo.total,
    loadBannerList: (state) => state.loadBannerList,
    loadBannerTotalRows: (state) => state.loadBannerPageInfo.total,
    loadNetworkListAll: (state) => state.loadNetworkListAll,
    loadNetworkAllTotalRows: (state) => state.loadNetworkAllPageInfo.total,    
    loadNetworkGroupListAll: (state) => state.loadNetworkGroupListAll,
    loadNetworkGroupAllTotalRows: (state) => state.loadNetworkGroupAllPageInfo.total,
    loadCampaignList: (state) => state.loadCampaignList,
    loadCampaignPresets: (state) => state.requirementPresets,
    loadCampaignTotalRows: (state) => state.loadCampaignPageInfo.total,
    loadProvidersList: (state) => state.loadProvidersList,
    loadProvidersTotalRows: (state) => state.loadProvidersPageInfo.total,
    loadNetworkGroupList: (state) => state.loadNetworkGroupList,
    loadNetworkGroupTotalRows: (state) => state.loadNetworkGroupPageInfo.total,
    campaignManagerList: (state) => state.campaignManagerList,
    rebateLogsList: (state) => state.rebateLogsList,
    rebateLogsTotal: (state) => state.rebateLogsPageInfo.total,
    scheduleRebateLogsList: (state) => state.scheduleRebateLogsList,
    scheduleRebateLogsTotal: (state) => state.scheduleRebateLogsPageInfo.total,
    schedulePromoLogsList: (state) => state.schedulePromoLogsList,
    schedulePromoLogsTotal: (state) => state.schedulePromoLogsPageInfo.total
  })
}

export const reportsMethods = mapActions('reports', [
  'getTopupLogs',
  'exportTopupLogs',
  'getEloadLogs',
  'exportEloadLogs',
  'fetchPaymongoTransaction',
  'getBlvckTopupLogs',
  'testReward',
  'getEloadTransactionDetails',
  'updateEloadTransactionStatus'
])

export const reportsComputed = {
  ...mapState('reports', {
    topupLogs: (state) => state.topupLogs,
    topupLogsTotalRows: (state) => state.topupLogsPageInfo.total,
    eloadLogs: (state) => state.eloadLogs,
    eloadLogsTotalRows: (state) => state.eloadLogsPageInfo.total,
    blvckTopupLogs: (state) => state.blvckTopupLogs,
    blvckTopupLogsTotalRows: (state) => state.blvckTopupLogsPageInfo.total,
  })
}

export const esellerMethods = mapActions('eseller', [
  'createSellerBrand',
  'updateSellerBrand',
  'listSellerBrands',
  'getSellerBrand',
  'listSellerCategories',
  'createSellerCategory',
  'updateSellerCategory',
  'deleteSellerCategory',
  'listSellerProducts',

  'createSellerBanner',
  'updateSellerBanner',
  'listSellerBanners',
  'deleteSellerBanner',

  'uploadLogo',
  'esellerOrders'
])

export const esellerComputed = {
  ...mapState('eseller', {
    brands: (state) => state.brands,
    esellerBrandTotalRows: (state) => state.brandPage.totalRows,
    esellerBrandNoOfPage: (state) => state.brandPage.noOfPage,
    categories: (state) => state.bussinessCategories,
    categoryTotalRows: (state) => state.bussinessCategoryPage.totalRows,
    products: (state) => state.products,
    productTotalRows: (state) => state.productPage.total,
    productPage: (state) => state.productPage,
    
    banners: (state) => state.banners,
    esellerBannerTotalRows: (state) => state.bannerPage.totalRows,
    
  })
}

export const eventListMethods = mapActions('eventList', [
  'createEventAPI',
  'eventList',
  'getEvent',
  'eventAttendee',
  'getAttendee',

  'uploadLogo',
  'removeUploadLogo',
  'deleteEventItem',
  'updateEventItem',
  'deleteAttendee',
  'addAttendee',
])

export const eventsComputed = {
  ...mapState('eventList', {
    events: (state) => state.events,
    eventTotalRows: (state) => state.eventPage.totalRows,
    attendees: (state) => state.attendees,
    attendeeTotalRows: (state) => state.attendeePage.totalRows,
    attendeesModal: (state) => state.attendeesModal,
    attendeeTotalRowsModal: (state) => state.attendeePageModal.totalRows,
  })
}
export const eloadRewardsMethods = mapActions('eloadRewards', [
  'getAllUsers',
  'createReward',
  'eloadRewardList',
  'rewardApproves',
  'uploadSupportingDocument',
  'actionEloadReward',
  'fetchUserDetails'
])
export const eloadRewardsComputed = {
  ...mapState('eloadRewards', {
    eloadRewards: (state) => state.eloadRewards,
    eloadRewardTotalRows: (state) => state.eloadRewardsPage.totalRows,
    userList: (state) => state.userList,
    userListTotalRows: (state) => state.userListPage.totalRows
  })
}

export const rouletteComputed = {
  ...mapState('roulette', {
    rouletteItem: (state) => state.rouletteItem,
    itemTotalRows: (state) => state.rouletteItemPage.totalRows,
    itemTotalPage: (state) => state.rouletteItemPage.totalPage,
    //MAIN
    rouletteMainDropdown: (state) => state.rouletteMainDropdown,
    rouletteMain: (state) => state.rouletteMain,
    mainTotalRows: (state) => state.rouletteMainPage.totalRows,
    mainTotalPage: (state) => state.rouletteMainPage.totalPage,
    //REWARDS
    rouletteRewards: (state) => state.rouletteRewards,
    rewardsTotalRows: (state) => state.rouletteRewardsPage.totalRows,
    rewardsTotalPage: (state) => state.rouletteRewardsPage.totalPage,
    // Winners Config
    rouletteWinnersConfigData: (state) => state.rouletteWinnersConfigData
  })
}

export const vcRewardsMethods = mapActions('vcRewards', [
  'fetchAllUsers',
  'fetchUsersVCLogs',
  'addUserVC'
])

export const vcRewardsComputed = {
  ...mapState('vcRewards', {
    vcRewards: (state) => state.vcRewards,
    vcRewardTotalRows: (state) => state.vcRewardsPage.totalRows,
    userList: (state) => state.userList,
    userListTotalRows: (state) => state.userListPage.totalRows
  })
}


export const rouletteMethods = mapActions('roulette', [
  'listRouletteItem',
  'createRouletteItem',
  'updateRouletteItem',
  'getRouletteItem',
  'deleteRouletteItem',
  'getRouletteItemPercentages',
  'listRouletteMain',
  'listRouletteMainDropdown',
  'getRouletteMain',
  'createRouletteMain',
  'updateRouletteMain',
  'listRouletteReward',
  'getRouletteReward',
  'createRecordRoulette',
  'listRouletteWinnersConfig',
  'createRouletteWinnersConfig',
  'updateRouletteWinnersConfig',
  'uploadLogo'
])

export const pushNotificationMethods = mapActions('pushNotification', [
  'pushMobileNotification'
])

export const exportMethods = mapActions('export',[
  'exportReport',
  'exportReportExt',
  'exportReportXLSL',
  'exportReportExtBatch'
])

export const prpComputed = {
  ...mapState('prp', {
    //REWARDS
    prpRewards: (state) => state.prpRewards,
    prpRewardsTotalRows: (state) => state.prpRewardsPage.totalRows,
    prpRewardsTotalPage: (state) => state.prpRewardsPage.totalPage,
  })
}
export const prpMethods = mapActions('prp', [
  'listPrpReward',
  'getPrpReward',
  'createRecordPRP',
  'uploadLogo',
  'actionPRP'
])


export const agentComputed = {
  ...mapState('agent', {
    agents: (state) => state.agents
  })
}

export const agentMethods = mapActions('agent',[
  'searchAgent',
  'disableAgent',
  'createAgent',
  'isExist'
]);


export const erpUserRolesMethods = mapActions('erpUserRoles', [
  'manageRole',
  'getRolesList',
  'readRole',
  'getAllRoles',
  'getAccess',
  'getRoleSettings'
]);

export const erpUserRolesComputed = {
  ...mapState('erpUserRoles', {
    rolesList: (state) => state.rolesList,
    rolesListTotalRows: (state) => state.rolesListPageInfo.total,
    roleAccess: (state) => state.roleAccess,
    roleSettings: (state) => state.roleSettings
  })
}

export const erpFixMessages = {//this will set general wordings for erp
  ...mapState({
    exportNullPrompt: () => `No data found, unable to export.`,
    paymentMethodList: () => [
      { text: "All", value: null },
      { text: 'Card', value: "card" },
      { text: "Gcash", value: "gcash" },
      { text: "BPI Banking", value: "BPI Banking" },
      { text: "Maya", value: "maya" },
      { text: "UnionBank", value: "UnionBank" }
    ]
  })
}

export const erpUsersMethods = mapActions('erpUsers', [
  'getErpUsersList',
  'readUser',
  'manageUser',
  'fetchLineManagers',
  'actionERPUsers'
])

export const erpUsersComputed = {
  ...mapState('erpUsers', {
    erpUsersList: (state) => state.erpUsersList,
    erpUsersTotalRows: (state) => state.erpUsersListPageInfo.total,
    erpManagerList: (state) => state.lineManagers
  })
}
export const billsPaymentMethods = mapActions('billsPayment', [
  'actionBillsPayment',
  'actionBillsPaymentCategory',
  'actionBillsPaymentProvider',
  'uploadLogo',
  'uploadLogo2',
  'actionBillsIncome'
])

export const billsPaymentCategoryMethodsComputed = {
  ...mapState('billsPayment', {
    billsPaymentCategory: (state) => state.billsPaymentCategory,
    billsPaymentCategoryTotalRows: (state) => state.billsPaymentCategoryPage.total,
    billsPaymentCategoryTotalPage: (state) => state.billsPaymentCategoryPage.totalPage,
    billsSellTxn: (state) => state.billsSellTxn,
    billsSellTxnTotal: (state) => state.billsSellTxnPageInfo.total,
    billsDailyIncoming: (state) => state.billsDailyIncoming,
    billsDailyOutgoing: (state) => state.billsDailyOutgoing,
    billsMonthlyIncoming: (state) => state.billsMonthlyIncoming,
    billsMonthlyOutgoing: (state) => state.billsMonthlyOutgoing,
  })
}

export const billsPaymentProviderMethodsComputed = {
  ...mapState('billsPayment', {
    billsPaymentProvider: (state) => state.billsPaymentProvider,
    billsPaymentProviderTotalRows: (state) => state.billsPaymentProviderPage.total,
    billsPaymentProviderTotalPage: (state) => state.billsPaymentProviderPage.totalPage,
  })
}

export const careersMethods = mapActions('career', [
  'actionCareers',
  'putInterviewSheet'
])

export const smartRaffleMethods = mapActions('smartRaffle', [
  'actionSmartRaffle'
])
export const smartRaffleComputed = {
  ...mapState('smartRaffle', {
    displayLoader: (state) => state.displayLoader
  })
}

export const mopComputed = {
  ...mapState('mop', {
    mopLoglist: (state) => state.mopLoglist,
    mopLogPageInfo: (state) => state.mopLogPageInfo,
    mopMethodTypes: (state) => state.mopMethodTypes,
    mops: (state) => state.mops,
    mopModules: (state) => state.mopModules,
    modules: (state) => state.modules,
    mopReasonLoglist: (state) => state.mopReasonLoglist,
    mopReasonLoglistTotalRows: (state) => state.mopReasonLogPageInfo.total,
    mopOptions: (state) => state.mopOptions,
    mopDetailsForm: (state) => state.mopDetailsForm,
  })
}

export const mopMethods = mapActions('mop', [
  'listMop',
  'createMop',
  'updateMop',
  'deleteMop',
  'getMop',
  'getMethodTypes',
  'listMopModules',
  'createMopModule',
  'updateMopModule',
  'deleteMopModule',
  'getMopModule',
  'getModules',
  'uploadLogo',
  'updateModuleOrder',
  'listAllMop',
  'updateMopStatus',
  'updateMopMethodStatus',
  'getMopReasonList',
  'getMopLogList',
  'exportMopLogList',
  'getMopModuleOpt',
  'actionMopDetailsScheduler',
  'testMopDetailsScheduler'
]);

export const kantoAdsMethods = mapActions('kantoads', [
  'getMcpTopupLogs',
  'getMcpTopup',
  'updateMcpTopup',
  'getTopupChangeLogs',
  'listAuditData',
  'fetchAuditSingleData',
  'updateAuditData',
  'fetchAuditLogsData',
  'getMcpCashoutList',
  'getMcpCashout',
  'updateMcpCashout',
  'getCashoutChangeLogs',
  'auditCancellationRequestList',
  'auditCollateralType',
  'fetchAuditCancallationRequest',
  'formAuditCancallationRequest',
  'auditCancellationRequestLogs'
]);

export const kantoAdsComputed = {
  ...mapState('kantoads', {
    mcpTopupLogs: (state) => state.mcpTopupLogs,
    mcpTopupLogsTotalRows: (state) => state.mcpTopupLogsPageInfo.total,
    mcpTopup: (state) => state.mcpTopup,
    mcpTopupChangeLogs: (state) => state.mcpTopupChangeLogs,
    mcpTopupChangeLogsTotal: (state) => state.mcpTopupChangeLogsPageInfo.total,
    auditData: (state) => state.auditData,
    auditDataTotalRows: (state) => state.auditDataPage.totalRows,
    auditDataTotalPage: (state) => state.auditDataPage.totalPage,
    auditLogsData: (state) => state.auditLogsData,
    auditLogsDataTotalRows: (state) => state.auditLogsDataPage.totalRows,
    auditLogsDataTotalPage: (state) => state.auditLogsDataPage.totalPage,
    mcpCashoutList: (state) => state.mcpCashoutList,
    mcpCashoutTotal: (state) => state.mcpCashoutPageInfo.total,
    mcpCashout: (state) => state.mcpCashout,
    mcpCashoutChangeLogs: (state) => state.mcpCashoutChangeLogs,
    mcpCashoutChangeLogsTotal: (state) => state.mcpCashoutChangeLogsPageInfo.total,
    cancellationList: (state) => state.cancellationList,
    cancellationTotal: (state) => state.cancellationListPageInfo.total,
    collateralOptions: (state) => state.collateralOptions,
    cancellationRequestDetails: (state) => state.cancellationRequestDetails,
    cancellationLogs: (state) => state.cancellationLogs,
    cancellationLogsTotal: (state) => state.cancellationLogsPageInfo.total,
  })
}

export const peddlrWalletKycMethods = mapActions('kyc', [
  'getUserKycStatus',
  'testUserKycStatus',
  'getUserKycDetails',
  'getUserKycPhotos',
  'getUserKycActivityLogs',
  'generateKycUrl',
])
export const peddlrWalletKycComputed = {
  ...mapState('kyc', {
    userKycStatus: (state) => state.userKycStatus,
    userKycDetails: (state) => state.userKycDetails,
    userKycPhotos: (state) => state.userKycPhotos,
    userKycActivityLogsList: (state) => state.userKycActivityLogsList,
    userKycActivityLogsTotal: (state) => state.userKycActivityLogsPageInfo.total,
    generatedKycUrl: (state) => state.generatedKycUrl,
  })
}

export const eRentaMethods = mapActions('erenta', [
  'getErentaFunds',
  'getErentaIncome',
  'getErentaTxn',
])
export const eRentaComputed = {
  ...mapState('erenta', {
    eRentaFunds: (state) => state.eRentaFunds,
    eRentaDailyIncoming: (state) => state.eRentaDailyIncoming,
    eRentaDailyOutgoing: (state) => state.eRentaDailyOutgoing,
    eRentaMonthlyIncoming: (state) => state.eRentaMonthlyIncoming,
    eRentaMonthlyOutgoing: (state) => state.eRentaMonthlyOutgoing,
    eRentaTxn: (state) => state.eRentaTxn,
    eRentaTxnTotal: (state) => state.eRentaTxnPageInfo.total,
  })
}

export const peddlrWalletMethods = mapActions('peddlrWallet', [
  'getPeddlrWalletDetails',
  'updatePeddlrWalletLimit',
  'getPeddlrWalletLimitLogs',
  'getPeddlrWalletTxn',
  'getKankolekCashinMethods',
  'updateWalletCashinMethodStatus',
  'getKankolekCashinMethodLogs',
  'getAdjustmentTransactionList',
  'getKankolekAccountList',
  'actionAdjustmentTransaction',
  'adjustmentAction',
  'uploadAdjustmentExcelFile',
  'invokeBulkProcessFunction',
])

export const peddlrWalletComputed = {
  ...mapState('peddlrWallet', {
    peddlrWalletDetails: (state) => state.peddlrWalletDetails,
    peddlrWalletLimitLogs: (state) => state.peddlrWalletLimitLogs,
    peddlrWalletLimitLogsTotal: (state) => state.peddlrWalletLimitLogsPageInfo.total,
    peddlrWalletTxn: (state) => state.peddlrWalletTxn,
    peddlrWalletTxnTotal: (state) => state.peddlrWalletTxnPageInfo.total,
    cashInMethods: (state) => state.cashInMethods,
    cashinMethodsLogs: (state) => state.cashinMethodsLogs,
    cashinMethodsLogsTotal: (state) => state.cashinMethodsLogsPageInfo.total,
    kankolekAdjustmentsList: (state) => state.kankolekAdjustmentsList,
    kankolekAdjustmentsTotal: (state) => state.kankolekAdjustmentsListPageInfo.total,
    kankolekAccountList: (state) => state.kankolekAccountList,
    kankolekAccountTotal: (state) => state.kankolekAccountListPageInfo.total,
  })
}

export const dashboardKankolekMethods = mapActions('dashboardKankolek', [
  'actionDashboardKankolek'
])

export const kkWebMethods = mapActions('kkWeb', [
  'actionKkWeb'
])

export const walletFreezingMethods = mapActions('walletFreezing', [
  'actionWalletFreezing'
])

export const transactionMonitoringMethods = mapActions('transactionMonitoring', [
  'actionTransactionMonitoring'
])

export const dashboardKankolekComputed = {
  ...mapState('dashboardKankolek', {
    kankolekDashboardSummary: (state) => state.kankolekDashboardSummary,
    kankolekActiveUsers: (state) => state.kankolekActiveUsers,
    kankolekWidgets: (state) => state.kankolekWidgets,
    kankolekTransactions: (state) => state.kankolekTransactions,
    kankolekTotalTransactions: (state) => state.kankolekTotalTransactions,
  })
}

export const maintenanceMethods = mapActions('maintenance', [
  'getMaintenanceModeData',
  'updateMaintenanceModeData',
  'getMaintenanceModeLogs',
  'updateSchedMaintenanceModeData',
  'actionPeddlrOption',
  'endScheduledMaintenance'
])

export const maintenanceComputed = {
  ...mapState('maintenance', {
    modules: (state) => state.modules,
    maintenanceLogsList: (state) => state.maintenanceLogsList,
    maintenanceLogsListTotal: (state) => state.maintenanceLogsList.total
    
  })
}

export const cifMethods = mapActions('cif', [
  'actionCIF'
])

export const peddlrNotificationMethods = mapActions('peddlrNotification', [
  'listPeddlrNotification',
  'getPeddlrNotificationDetails',
  'notificationAction',
  'listPeddlrNotificationModules'
])

export const peddlrNotificationComputed = {
  ...mapState('peddlrNotification', {
    peddlrNotifications: (state) => state.peddlrNotifications,
    peddlrNotificationsTotal: (state) => state.peddlrNotificationPageInfo.total,
    peddlrNotificationDetails: (state) => state.peddlrNotificationDetails,
    peddlrNotificationModules: (state) => state.peddlrNotificationModules,
  })
}

export const eloadB2BMethods = mapActions('eloadB2B', [
  'getEloadB2BRequests',
  'uploadEloadB2BDepositImg',
  'saveEloadB2BRequest',
  'getEloadB2BUsers',
  'getEloadB2BBanks',
  'getEloadB2BRequestDetails',
  'postApprovedRequest',
  'postRejectedRequest',
  'clearRequestDetails'
])

export const eloadB2BComputed = {
  ...mapState('eloadB2B', {
    eloadB2BRequests: (state) => state.eloadB2BRequests,
    eloadB2BRequestsTotal: (state) => state.eloadB2BRequestsTotal,
    eloadB2BRequestDetails: (state) => state.eloadB2BRequestDetails,
    eloadB2BUsers: (state) => state.eloadB2BUsers,
    eloadB2BBanks: (state) => state.eloadB2BBanks,
    eloadB2BPeddlrBanks: (state) => state.eloadB2BPeddlrBanks,
    eloadB2BDefaultRebate: (state) => state.eloadB2BDefaultRebate, 
  })
}

export const gbitsEloadTopupMethods = mapActions('gbitsEloadTopup', [
  'getEloadB2BRequests',
  'uploadEloadB2BDepositImg',
  'saveEloadB2BRequest',
  'getEloadB2BUsers',
  'getEloadB2BBanks',
  'getEloadB2BRequestDetails',
  'postApprovedRequest',
  'postRejectedRequest',
  'clearRequestDetails',
  'exportTopupRequests',
  'getTopupAccess',
  'getBusinessNames'
])

export const gbitsEloadTopupComputed = {
  ...mapState('gbitsEloadTopup', {
    eloadB2BRequests: (state) => state.eloadB2BRequests,
    eloadB2BRequestsTotal: (state) => state.eloadB2BRequestsTotal,
    eloadB2BRequestDetails: (state) => state.eloadB2BRequestDetails,
    eloadB2BUsers: (state) => state.eloadB2BUsers,
    eloadB2BBanks: (state) => state.eloadB2BBanks,
    eloadB2BPeddlrBanks: (state) => state.eloadB2BPeddlrBanks,
    eloadB2BDefaultRebate: (state) => state.eloadB2BDefaultRebate,
    eloadB2BBusinessNames: (state) => state.eloadB2BBusinessNames,
  })
}

export const eloadMaintenanceMethods = mapActions('eloadMaintenance', [
  'getEloadMaintenanceList',
  'getEloadMaintenanceDetails',
  'saveEloadMaintenance',
  'getEloadMaintenanceLogs',
  'getEloadMaintenanceOptions',
  'updateEloadMaintenance',
  'actionEloadMaintenance',
  'cancelEloadMaintenance',
  'getEloadMaintenanceAuditLogs',
  'exportEloadMaintenanceAuditLogs'
])

export const eloadMaintenanceComputed = {
  ...mapState('eloadMaintenance', {
    eloadMaintenanceList: (state) => state.eloadMaintenanceList,
    eloadMaintenanceTotal: (state) => state.eloadMaintenanceTotal,
    eloadMaintenanceDetails: (state) => state.eloadMaintenanceDetails,
    eloadMaintenanceLogs: (state) => state.eloadMaintenanceLogs,
    eloadMaintenanceLogsTotal: (state) => state.eloadMaintenanceLogsTotal,
    eloadLogsCreatedBy: (state) => state.eloadLogsCreatedBy,
    eloadLogsCreatedAt: (state) => state.eloadLogsCreatedAt,
    eloadMaintenanceProvider: (state) => state.eloadMaintenanceProvider,
    eloadMaintenanceNetwork: (state) => state.eloadMaintenanceNetwork,
    eloadMaintenanceNetworkGroup: (state) => state.eloadMaintenanceNetworkGroup,
  })
}



export const eloadProviderMethods = mapActions('eloadProvider', [
  'actionEloadProvider'
])

export const eloadProviderComputed = {
  ...mapState('eloadProvider', {
    tblCount: (state) => state.tblCount,
  })
}

export const smsBlastCampaignMethods = mapActions('smsBlast', [
  'actionSMSBlastAPIPOST'
])


/* Digital Core Eload Helpers */
// Core SKU test
export const coreEloadSKUTestMethods = mapActions('skutest', [
  'actionCoreSKUTestAPIPOST',
  'actionCoreSKUTestAPIGET'
])

// Eload Core Provider
export const coreEloadProviderMethods = mapActions('digitalcoreEloadProvider', [
  'actionCoreEloadProviderAPIPOST',
])

// Eload Core Network
export const coreEloadNetworkMethods = mapActions('digitalcoreEloadNetwork', [
  'actionCoreEloadNetworkAPIPOST',
])

// Eload Core Dropdown
export const coreEloadDropdownMethods = mapActions('digitalcoreEloadDropdown', [
  'fetchCoreNetworksList',
  'fetchCoreProvidersList',
  'fetchCoreCategoriesList',
  'fetchCoreServicesList',
  'fetchCoreUnlistedSKUList',
  'fetchCoreListedSKUList',
])

export const coreEloadDropdownComputed = {
  ...mapState('digitalcoreEloadDropdown', {
    getCoreNetworksList: (state) => state.networksList,
    getCoreProvidersList: (state) => state.providersList,
    getCoreCategoriesList: (state) => state.categoriesList,
    getCoreServicesList: (state) => state.servicesList,
    getCoreUnlistedSKUList: (state) => state.unlistedSKUList,
    getCoreListedSKUList: (state) => state.listedSKUList,
  })
}
export const coreEloadSKUMasterComputed = {
  ...mapState('digitalcoreEloadSkumaster', {
    loadPromoList: (state) => state.loadPromoList,
    loadPromoTotalRows: (state) => state.loadPromoPageInfo.total,
  })
}

export const coreEloadSKUMasterMethods = mapActions('digitalcoreEloadSkumaster', [
  'actionCoreEloadSKUMasterAPIPOST',
])

export const coreEloadMaintenanceMethods = mapActions('digitalcoreEloadMaintenance', [
  'actionCoreEloadMaintenanceAPIPOST',
])

export const coreEloadSKUMainComputed = {
  ...mapState('digitalcoreEloadSkumain', {
    loadPromoList: (state) => state.loadPromoList,
    loadPromoTotalRows: (state) => state.loadPromoPageInfo.total,
  })
}

export const coreEloadSKUMainMethods = mapActions('digitalcoreEloadSkumain', [
  'actionCoreEloadSKUMainAPIPOST',
])

export const coreEloadSKUSchedulingComputed = {
  ...mapState('digitalcoreEloadSkuscheduling', {
    loadPromoList: (state) => state.loadPromoList,
    loadPromoTotalRows: (state) => state.loadPromoPageInfo.total,
  })
}

export const coreEloadSKUSchedulingMethods = mapActions('digitalcoreEloadSkuscheduling', [
  'actionCoreEloadSKUSchedulingAPIPOST',
])

// E-Load Dashboard
export const eloadDashboardComputed = {
  ...mapState('digitalcoreEloadDashboard', {
    eloadSummary: (state) => state.eloadSummary,
    activeUsers: (state) => state.activeUsers,
    retailDailyTransactions: (state) => state.retailDailyTransactions,
    retailDailyDates: (state) => state.retailDailyDates,
    b2bDailyTransactions: (state) => state.b2bDailyTransactions,
    b2bDailyTransactionsPerProvider: (state) => state.b2bDailyTransactionsPerProvider,
    b2bDailyDates: (state) => state.b2bDailyDates,
    dailyTransactionsPerProvider: (state) => state.dailyTransactionsPerProvider,
    dailyDates: (state) => state.dailyDates,
  })
}

export const eloadDashboardMethods = mapActions('digitalcoreEloadDashboard', [
  'getELoadSummary',
  'getActiveUsers',
  'getRetailDailyTransactions',
  'getB2BDailyTransactions',
  'getDailyTransactionsPerProvider'
])

// Puhunan CTR Report
export const puhunanCampaignComputed = {
  ...mapState('puhunanCampaign', {
    ctrCards: (state) => state.ctrCards,
    ctrRows: (state) => state.ctrRows,
    ctrPageInfo: (state) => state.ctrPageInfo,
  })
}

export const puhunanCampaignMethods = mapActions('puhunanCampaign', [
  'getPuhunanCTRReport',
  'exportPuhunanCTRReport'
])

// Puhunan Loan Offers
export const puhunanOffersComputed = {
  ...mapState('puhunanOffers', {
    offerKpi: (state) => state.offerKpi,
    offerRows: (state) => state.offerRows,
    offerPageInfo: (state) => state.offerPageInfo,
  })
}

export const puhunanOffersMethods = mapActions('puhunanOffers', [
  'getPuhunanOffersKPI',
  'getPuhunanOffersList',
  'exportPuhunanOffers'
])

// Puhunan Loan Disbursed
export const puhunanLoansComputed = {
  ...mapState('puhunanLoans', {
    loanKpi: (state) => state.loanKpi,
    loanRows: (state) => state.loanRows,
    loanPageInfo: (state) => state.loanPageInfo,
  })
}

export const puhunanLoansMethods = mapActions('puhunanLoans', [
  'getPuhunanLoansKPI',
  'getPuhunanLoansList',
  'exportPuhunanLoans'
])

// Peddlr Lite - Eload SKU

/* Digital Lite Eload Helpers */
export const liteEloadDropdownMethods = mapActions('digitalliteEloadDropdown', [
  'fetchLiteNetworksList',
  'fetchLiteNetworkCategoryList',
])

export const liteEloadDropdownComputed = {
  ...mapState('digitalliteEloadDropdown', {
    getLiteNetworksList: (state) => state.networksList,
    getLiteNetworkCategoryList: (state) => state.networkCategoryList,
  })
}

export const liteEloadCategoryMethods = mapActions('digitalliteEloadCategory', [
  'getLiteCategoryList',
  'actionLiteCategory',
  'getLiteCategoryDetails',
  'uploadLiteSpecialCategoryIcon2',
  'getLiteCategoryAuditLogs',
  'exportLiteCategoryAuditLogs',
])

export const liteEloadCategoryComputed = {
  ...mapState('digitalliteEloadCategory', {
    liteCategoryList: (state) => state.categoryList,
    liteCategoryTotalRows: (state) => state.categoryPageInfo.total,
    liteCategoryDetails: (state) => state.categoryDetails,
    liteCategoryLogs: (state) => state.categoryLogs,
    liteCategoryLogsTotal: (state) => state.categoryLogsTotal,
  })
}

export const gbitsMethods = mapActions('gbits', [
  'actionGbitsInvitation'
])

/* ─────────────────────────────────────────────────────────────────────────────
 * Peddlr Lite (PEDDLR-7104) merchant listing/details helpers.
 * These map to the lite Vuex modules `customerLite` (customer-lite.js) and
 * `kycLite` (kyc-lite.js), which talk to the /v6/lite gateway (peddlr_v6).
 * They mirror the Peddlr App helpers (customerMethods / customerListComputed /
 * peddlrWalletKycMethods / peddlrWalletKycComputed) but never touch the App store.
 * ───────────────────────────────────────────────────────────────────────────── */
export const customerLiteMethods = mapActions('customerLite', [
  'getSubscriberListv2',
  'getBusinessDetailsv2',
  'fetchSecQueHistory',
  'getKankolekMDR',
  'getKankolekMdrLogs',
  'getUserKankolekQR',
  'updateMdrWhitelist',
  'updateWatchlistStatus',
  'updateStoreCategory',
  'updateAccountType',
  'presignAccountTypeDocument',
  'getAccountTypeDocumentHistory',
  'downloadAccountTypeDocument',
  'sendSecQue',
  'getBusinessEloadTransaction',
  'getEloadTopupLogs',
  'getEloadSellLogs',
  'updateUserWalletStatus',
  'getUserWalletsList',
  'getReasonLogsList',
])

export const customerListLiteComputed = {
  ...mapState('customerLite', {
    businessDetails: (state) => state.businessDetails,
    subscriberList: (state) => state.subscriberList,
    subscriberListTotal: (state) => state.subscriberPageInfo.total,
    secQueHistory: (state) => state.secQueHistory,
    reasonLogsList: (state) => state.reasonLogsList,
    reasonLogsTotal: (state) => state.reasonLogsPageInfo.total,
    eloadTopupLogs: (state) => state.eloadTopupLogs,
    eloadTopupLogsTotalRows: (state) => state.eloadTopupLogsPageInfo.total,
    eloadSellLogs: (state) => state.eloadSellLogs,
    eloadSellLogsTotalRows: (state) => state.eloadSellLogsPageInfo.total,
  })
}

export const peddlrWalletKycLiteMethods = mapActions('kycLite', [
  'getUserKycStatus',
  'testUserKycStatus',
  'getUserKycDetails',
  'getUserKycPhotos',
  'getUserKycActivityLogs',
  'generateKycUrl',
  'getWatchlistFlag',
  'presignWatchlistDocument',
  'clearWatchlist',
  'blockWatchlist',
  'getWatchlistDecisionDetails',
  'downloadWatchlistDocument',
])

export const peddlrWalletKycLiteComputed = {
  ...mapState('kycLite', {
    userKycStatus: (state) => state.userKycStatus,
    userKycDetails: (state) => state.userKycDetails,
    userKycPhotos: (state) => state.userKycPhotos,
    userKycActivityLogsList: (state) => state.userKycActivityLogsList,
    userKycActivityLogsTotal: (state) => state.userKycActivityLogsPageInfo.total,
    generatedKycUrl: (state) => state.generatedKycUrl,
    watchlistFlag: (state) => state.watchlistFlag,
    watchlistDecisionDetails: (state) => state.watchlistDecisionDetails,
  })
}
